export default __webpack_public_path__ + "static/media/team-1.ccc3acec.jpg";